var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpoons = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7.167 13.367 3.256-3.429-8.077-8.494C.551 3.334.551 6.4 2.346 8.302l4.821 5.065Zm7.8-2.193c1.761.86 4.235.255 6.065-1.672 2.197-2.314 2.623-5.634.931-7.416-1.68-1.769-4.832-1.332-7.041.982-1.83 1.926-2.405 4.532-1.588 6.385L2.104 21.28l1.623 1.709 7.927-8.324L19.57 23l1.622-1.709-7.915-8.336 1.69-1.781Z",
  fill: "currentColor",
  fillRule: "nonzero"
})));
export default SvgSpoons;